import { forwardRef, ForwardedRef } from 'preact/compat';
import { multiVariantStyles } from './themes/ModalStyles.css';
import { HTMLAttributesSignalExcluded } from '../utils/UNSAFE_attributeUtils';

type IntrinsicProps = Pick<HTMLAttributesSignalExcluded<HTMLDivElement>, 'children'>;

type Props = IntrinsicProps & {
  /**
   * Specifies the backdrop is visible or transparent. Default is 'scrim' (visible).
   */
  variant?: 'scrim' | 'transparent';
};

const ModalBackdrop = forwardRef<HTMLDivElement, Props>(
  ({ variant = 'scrim' }, ref: ForwardedRef<HTMLDivElement | null>) => {
    const variantClasses = multiVariantStyles({
      backdrop: variant === 'transparent' ? 'transparent' : 'scrim'
    });

    return <div ref={ref} class={variantClasses} />;
  }
);

export default ModalBackdrop;
